import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "./BreadCrumb.css";

export default function BreadCrumb({ activeCategory, activeParentCategory, searchQuery }) {
  let title = "Shop";
  let description = "Browse our extensive collection of high-quality textiles, carpets, rugs, and apparel designed to bring style and comfort into your life.";
  
  if (searchQuery) {
    title = `Search Results`;
    description = `Showing products matching "${searchQuery}". Browse our extensive collection to find the perfect match.`;
  } else if (activeCategory) {
    title = activeCategory.name;
    
    // Generate a matching description based on category name
    const name = activeCategory.name.toLowerCase();
    if (name.includes("rug") || name.includes("carpet")) {
      description = `Introducing our collection of carpets and rugs, designed to add comfort, luxury, and style to any room in your home. Inspired by the latest design trends and made with the highest quality materials.`;
    } else if (name.includes("apparel") || name.includes("suit") || name.includes("robe") || name.includes("scarf")) {
      description = `Discover our premium collection of lifestyle apparel. Beautifully crafted with comfortable, breathable fabrics designed to add elegant style and coziness to your daily routine.`;
    } else if (name.includes("textile") || name.includes("cover") || name.includes("bedspread") || name.includes("quilt") || name.includes("throw") || name.includes("mat")) {
      description = `Introducing our collection of home textiles, cushions, and covers. Designed to add comfort, elegance, and unique texture to your home decor. Crafted from the finest fabrics.`;
    } else {
      description = `Explore our collection of ${activeCategory.name}. High-quality materials and exquisite craftsmanship make these products the perfect addition to bring style and comfort into your life.`;
    }
  }

  return (
    <div className="breadCrumb_main">
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="breadcrumb_title">
              <Breadcrumb>
                <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/products">Shop</Breadcrumb.Item>
                
                {activeParentCategory && (
                  <Breadcrumb.Item href={`/products?category=${activeParentCategory.slug}`}>
                    {activeParentCategory.name}
                  </Breadcrumb.Item>
                )}
                
                {searchQuery ? (
                  <Breadcrumb.Item active>Search: {searchQuery}</Breadcrumb.Item>
                ) : activeCategory ? (
                  <Breadcrumb.Item active>{activeCategory.name}</Breadcrumb.Item>
                ) : (
                  <Breadcrumb.Item active>Shop</Breadcrumb.Item>
                )}
              </Breadcrumb>
              <h1>{title}</h1>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="breadcrumb_desc">
              <p>{description}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
